.listItem {
  width: 100%;

  display: flex;
  flex-direction: column;
  justify-content: stretch;
  align-items: center;
}

.searchItemContainer {
  width: 100%;
  display: flex;
  justify-content: stretch;
  align-items: flex-start;
  padding: 0.5rem;
  min-width: 0;
}
.searchItemContainer:not(:last-child) {
  border-bottom: 1px solid var(--static-divider-standard);
}

.searchItemContainer:hover {
  outline: 1px solid var(--static-divider-standard);
}

.minWidth0 {
  min-width: 0;
}

.listItemLeftColumn {
  width: 100%;
  min-width: 0;
  padding: 0 0.5rem;
}

.listItemRightColumn {
  min-width: 0;
  white-space: nowrap;
  min-width: max-content;
}

.listItemTitle {
  display: block;
  max-width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.listItemMultipleSkuContainer {
  width: 100%;
  padding: 0.5rem;
  border-top: 1px dashed var(--static-divider-standard);
}

.listItemMultipleSkuTitle {
  margin-bottom: 10px;
}

.multipleSkuColumn {
  transition: max-height 300ms ease-in-out;
  /* @TODO right now if an expanded list overflows 100vh, you'll have items you can't scroll to,
    because of a flexbox limitation */
  max-height: 100vh;
  overflow: hidden;
}
.multipleSkuColumn.collapsed{
  transition: max-height 300ms cubic-bezier(0, 1, 0, 1);
  max-height: 2.25rem; /* coupled to the height of the 'add' rows and the 'expand/collapse' button */
  overflow: hidden;
}

.divider {
  height: 1px;
  width: 100%;
  margin: 0 10px;
  background-color: var(--static-divider-standard);
}

.truncate {
  max-width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.labelNoTruncate {
  min-width: max-content;
}

.listingBadgeContainer {
  margin-right: 10px;
}